module.exports = __webpack_public_path__ + "img/logo_dukcapil.f3dffe86.png";